"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FilterListItem = /** @class */ (function (_super) {
    __extends(FilterListItem, _super);
    function FilterListItem(type, order, header, name, value, selectionType, filters) {
        if (selectionType === void 0) { selectionType = 'multi_select'; }
        var _this = _super.call(this) || this;
        _this.getOrdered = function () { return _this.sort(function (x, y) { return (x.order > y.order ? 1 : -1); }); };
        _this.order = order;
        _this.header = header;
        _this.name = name;
        _this.value = value;
        _this.type = type;
        _this.selectionType = selectionType;
        if (filters !== null && filters !== undefined) {
            filters.forEach(function (filter) { return _this.push(filter); });
        }
        return _this;
    }
    FilterListItem.fromArray = function (type, order, header, name, value, selectionType, filters) { return new FilterListItem(type, order, header, name, value, selectionType, filters); };
    return FilterListItem;
}(Array));
exports.default = FilterListItem;
//# sourceMappingURL=FilterListItem.js.map